import { AtendimentoVacinacaoInput } from 'graphql/types.generated'
import { convertDesfechoFormToInput } from 'view/atendimentos/detail/soap/desfecho'

import { convertCondicoesToInput } from '../condicoes/converter'
import { AtendimentoVacinacaoState } from '../model'
import { convertRegistroVacinacaoToInput } from '../registros/converter'

export const convertAtendimentoVacinacaoModelToInput = (
  atendimentoId: ID,
  cidadaoId: ID,
  values: AtendimentoVacinacaoState
): AtendimentoVacinacaoInput => ({
  id: atendimentoId,
  finalizadoEm: new Date().getTime(),
  condicoesVacinacao: convertCondicoesToInput(values.condicoesVacinacao),
  desfechoVacinacao: convertDesfechoFormToInput(cidadaoId, values.desfechoVacinacao),
  registroVacinacao: convertRegistroVacinacaoToInput(values.registroVacinacao),
})
